// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"ExpenseGroupPage_buttonBox__3SQ72","confirmationDate":"ExpenseGroupPage_confirmationDate__1MTx-"};